"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.SET_SEND_TYPING = void 0; // TODO: [P3] Take this deprecation code out when releasing on or after 2020 January 13

var SET_SEND_TYPING = 'WEB_CHAT/SET_SEND_TYPING';
exports.SET_SEND_TYPING = SET_SEND_TYPING;

function _default(value) {
  // Deprecation notes added to reducer
  return {
    type: SET_SEND_TYPING,
    payload: {
      sendTyping: !!value
    }
  };
}